module.exports = __webpack_public_path__ + "img/login-violet.a0a42fb5.svg";